import React from 'react';
import TopBar from '../components/TopBar';
import MobileNavTabs from '../components/MobileNavTabs';
import DesktopSidebar from '../components/DesktopSidebar';
import desktopLayout from '../components/DesktopSidebarLayout.module.css';
import layoutStyles from '../styles/layout.module.css';
import ArtistList from '../artists/artistList';

export default function Home() {
  return (
    <div className={layoutStyles.homeContainer} style={{ paddingBottom: 0 }}>
      <TopBar hideLeft>
        <div className={desktopLayout.mobileTabs}>
          <MobileNavTabs />
        </div>
      </TopBar>
      <div className={`${desktopLayout.shell} ${desktopLayout.shellWithRail}`.trim()}>
        <DesktopSidebar active="home" note="Artist discovery, live drops, and public pages now live in one editorial-style browse experience." />
        <main className={desktopLayout.main}>
          <div className={desktopLayout.mainInner}>
            <ArtistList embedded />
          </div>
        </main>
      </div>
    </div>
  );
}
